import React from 'react';
import { useNavigate } from 'react-router-dom';
import FullWidthLayout from '../layouts/FullWidthLayout';
import Button from '@mui/joy/Button';
import Container from './Container';

const NotFound = (props) => {
	const navigate = useNavigate();

	return (
		<>
			<div style={{
				textAlign: 'center',
				marginBottom: 300,
			}}>
				<h1><small>Not found</small></h1>
				<Button onClick={() => navigate('/')}>Back to safety</Button>
			</div>
		</>
	);
};

export default NotFound;
